import { isProd } from '@m/config/FeatureFlags';

export const BOULDER_RATE_SUMMARY = { priceFormatted: '$1.75', rateLabel: '1st hour' } as const;

export const BOULDER_PROD_SITES: number[] = [1638, 1639, 1640, 1641, 1642];
export const BOULDER_TEST_SITES: number[] = [1, 2, 2615];

export const BEAR_LOT_PROD_SITES: number[] = [3449];
export const BEAR_LOT_TEST_SITES: number[] = [3449];

export const ELK_LOT_PROD_SITES: number[] = [3554];
export const ELK_LOT_TEST_SITES: number[] = [3554];

export const isBoulderRate = (siteId: number) => {
  if (isProd && BOULDER_PROD_SITES.includes(siteId)) {
    return true;
  }
  if (!isProd && BOULDER_TEST_SITES.includes(siteId)) {
    return true;
  }
  return false;
};

export const isBearLotRate = (siteId: number) => {
  if (isProd && BEAR_LOT_PROD_SITES.includes(siteId)) {
    return true;
  }
  if (!isProd && BEAR_LOT_TEST_SITES.includes(siteId)) {
    return true;
  }
  return false;
};

export const isElkLotRate = (siteId: number) => {
  if (isProd && ELK_LOT_PROD_SITES.includes(siteId)) {
    return true;
  }
  if (!isProd && ELK_LOT_TEST_SITES.includes(siteId)) {
    return true;
  }
  return false;
};
